export default __webpack_public_path__ + "static/media/income-w.a4248265.png";